import { render, staticRenderFns } from "./cptList.vue?vue&type=template&id=c1a4d606&"
import script from "./cptList.vue?vue&type=script&lang=js&"
export * from "./cptList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports